import { render, staticRenderFns } from "./customMDTSpecialist.vue?vue&type=template&id=52462ad1&scoped=true&"
import script from "./customMDTSpecialist.vue?vue&type=script&lang=js&"
export * from "./customMDTSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52462ad1",
  null
  
)

export default component.exports